<template>
  <el-card>
    <div class="wrap-rub center">
      <div class="wrap-left">
        <div class="title">
          <img src="https://public-static-edu.codemao.cn/redboat/courseManage/老师的话.png" />
          <h3>老师的话！</h3>
        </div>
        <i></i>
      </div>
    </div>
    <div class="content">
      <p v-html="$xss(target)"></p>
    </div>
    <div class="teacher">
      <span></span>
    </div>
    <footer class="footer"></footer>
  </el-card>
</template>

<script>
import { Card } from 'element-ui'

export default {
  components: {
    'ElCard': Card
  },
  props: ['data'],
  data () {
    return {
      target: ''
    }
  },
  watch: {
    'data': {
      handler (val) {
        this.$nextTick(() => {
          // 有换行
          if (!val) return
          const str = val.remark
          if (/[\n\r]/g.test(str)) {
            this.target = str.replace(/[\n\r]/g, '<br/>')
          } else {
            this.target = str
          }
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './view.styl';

.wrap-rub {
  display: flex;
}

.wrap-left {
  position relative

  i {
    display block
    width: 44px;
    height: 28px;
    background: url('https://public-static-edu.codemao.cn/redboat/courseManage/老师的话2.png') no-repeat 100% / cover;
    position: absolute;
    right: 15px;
    bottom -2px;
  }
}

.content {
  min-height: 149px;
  background: rgba(15, 64, 37, 1);
  border-radius: 10px;
  border: 3px solid rgba(6, 240, 213, 1);
  margin: auto;
  position: relative;
  z-index: 1;
  padding: 25px 15px;
  color: #fff;
  overflow: auto;

  p {
    font-size: 12px;
    word-break: break-all;
  }
}

.teacher {
  position: relative;

  span {
    width: 76px;
    height: 107px;
    background: url('https://public-static-edu.codemao.cn/redboat/courseManage/teacher.png') no-repeat 100% / cover;
    position: absolute;
    top: -40px;
    left: -16px;
    z-index: 1;
  }
}

.footer {
  transform: rotate(180deg);
  margin-top: -100px;
  position: relative;
  width: 115%;
  left: -20px;
  top: 20px;

  &::after {
    content: '';
    display: block;
    width: 155px;
    height: 24px;
    background: url('https://public-static-edu.codemao.cn/redboat/courseManage/老师的话4.png') no-repeat 100% / cover;
    transform: rotate(-180deg);
    position: absolute;
    top: 0;
    right: 43%;
  }
}
</style>
